import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  BetNotificationWr,
  freeBetStore,
  SlowConnectionWr,
  UnderMaintenanceWr,
} from '@pascal/pascal-core';
import GameContentWeb from '../containers/web/gameContentWeb';
import { GameContent } from '../containers/common/gameContent';
import { MIN_ODD } from '../enums/uiConfig';
import { GameMain } from './GameDrawer';
import { MaxPayOutPopUp } from '../components/common/maxPayOutPopUp';
import { MaxWinPopup } from '../components/common/maxWinPopUp';

export const Game = observer(() => {
  const { activeFreeBet } = freeBetStore;

  return (
    <>
      <GameContent innerComp={GameContentWeb} />
      <GameMain />
      <MaxPayOutPopUp />
      <MaxWinPopup />
      <BetNotificationWr autoCashOutMinOdd={activeFreeBet?.id ? activeFreeBet?.minOdd : MIN_ODD} />
      <SlowConnectionWr />
      <UnderMaintenanceWr />
    </>
  );
});
